import { Component, OnInit } from '@angular/core';
import { AdminServiceService } from '../../service/admin-service.service';
import { UiService } from '../../service/ui.service';

@Component({
  selector: 'app-trial-prices',
  templateUrl: './trial-prices.component.html',
  styleUrls: ['./trial-prices.component.scss'],
})
export class TrialPricesComponent implements OnInit {
  public planes = [];
  public directoryPrice = 0;
  public storePrice = 0;

  constructor(
    private adminSv: AdminServiceService,
    private uiSv: UiService
  ) { }

  async ngOnInit() {
    const res: any[] = await this.adminSv.getPrices();
    this.planes = res;
    console.log(this.planes);
    
    // res.map(x => {

    // })
    console.log(res);
  }

  savePrices(){
    this.planes.forEach(async (x: any) => {
      const res = await this.adminSv.postPrices(x);
      if(res.status){
        await this.uiSv.showToast('Precios actualizados con exito');
      }
    })
  }
}
